import { useLocalStorage } from 'react-use'

type useTrackLastProfileChangesRuturnType = {
  lastChangesId: number
  setTrackId: (id: string | number) => void
  removeTrackId: () => void
}

export const useTrackLastProfileChanges = (): useTrackLastProfileChangesRuturnType => {
  const [value, setValue, remove] = useLocalStorage('lastProffileChangesId', '')

  return {
    lastChangesId: Number(value) ?? 0,
    setTrackId: (id: string | number) => {
      setValue(String(id))
    },
    removeTrackId: remove,
  }
}
